import { render, staticRenderFns } from "./ModalAgregarHorario.vue?vue&type=template&id=a1e96dda&scoped=true&"
import script from "./ModalAgregarHorario.vue?vue&type=script&lang=js&"
export * from "./ModalAgregarHorario.vue?vue&type=script&lang=js&"
import style0 from "./ModalAgregarHorario.vue?vue&type=style&index=0&id=a1e96dda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e96dda",
  null
  
)

export default component.exports